import removeListener from './removeListener';
function addEventListener(element, eventName, fnName) {
  const normalElement = element;
  const operaElement = element;
  if (normalElement.addEventListener) {
    normalElement.addEventListener(eventName, fnName, false);
  } else if (operaElement.attachEvent) {
    operaElement.attachEvent("on".concat(eventName), fnName);
  }
}
function addListener(element, eventName, func) {
  addEventListener(element, eventName, func);
  return () => removeListener(element, eventName, func);
}
export default addListener;